import React from "react";
import { createRoot } from "react-dom/client";
import "./styles/_variables.css";
import "./styles/index.css";
import "@mantine/charts/styles.css";
import "@mantine/core/styles.css";
import "@mantine/charts/styles.css";
import "@mantine/carousel/styles.css";
import "@mantine/notifications/styles.css";
import "@mantine/dates/styles.css";
import "@mantine/schedule/styles.css";
import App from "./App";
import i18n from "./i18n";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { I18nextProvider } from "react-i18next";
import { BrowserRouter } from "react-router-dom";
import { BrandingProvider } from "@/contexts/BrandingContext";
import { ModalProvider } from "@/contexts/ModalContext";
import { Notifications } from "@mantine/notifications";
import GlobalModal from "@/components/organisms/GlobalModal";
import { AuthProvider } from "@/contexts/AuthContext";

const container = document.getElementById("root");
if (!container) throw new Error("Root element not found");

const root = createRoot(container);
const queryClient = new QueryClient();

root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <BrowserRouter>
        <BrandingProvider>
          <QueryClientProvider client={queryClient}>
            <AuthProvider>
              <ModalProvider>
                <ReactQueryDevtools initialIsOpen={false} />
                <App />
                <GlobalModal />
              </ModalProvider>
              <Notifications position="bottom-left" />
            </AuthProvider>
          </QueryClientProvider>
        </BrandingProvider>
      </BrowserRouter>
    </I18nextProvider>
  </React.StrictMode>,
);
